export default "/images/6d31969cfa7a159a4bf6acfad664d613.avif";